import { render, staticRenderFns } from "./growthdb.vue?vue&type=template&id=1e2ef3e0&scoped=true"
import script from "./growthdb.vue?vue&type=script&lang=js"
export * from "./growthdb.vue?vue&type=script&lang=js"
import style0 from "./growthdb.vue?vue&type=style&index=0&id=1e2ef3e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2ef3e0",
  null
  
)

export default component.exports